import { SET_CURRENT_LANG } from "./types";

export const setCurrentLang = (payload) => {
  localStorage.setItem("lang", payload);
  return { type: SET_CURRENT_LANG, payload };
};
